<template>
  <div>
    <nav-breadcrumb :menu="[{label: dealerId ? '编辑渠道商' : '新增渠道商'}]"/>

    <el-row>
      <el-col>
        <panel label="基本信息">
          <el-form :model="dealerForm" :rules="dealerFormRules" ref="dealerForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
              <el-col :span="12" v-if="dealerForm.d__dealerCode==''">
                <el-form-item label="渠道商编号：" style="width: 60%">
                  <el-input value="待生成" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dealerForm.d__dealerCode!=''">
                <el-form-item label="渠道商编号：" style="width: 60%">
                  <el-input v-model="dealerForm.d__dealerCode" disabled></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="渠道商名称：" prop="d__dealerName" style="width: 60%">
                  <el-input v-model="dealerForm.d__dealerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="渠道商等级：" prop="d__dealerTypeId" :rules="{required: true, message: '渠道商等级不能为空'}"
                              style="width: 60%">
                  <el-select placeholder="请选择渠道商等级" v-model.trim="dealerForm.d__dealerTypeId">
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in deviceTypeOptions"
                               :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="负责人：" prop="d__personInCharge" style="width: 60%">
                  <el-input v-model="dealerForm.d__personInCharge"></el-input>
                </el-form-item>
              </el-col>
              <!--            <el-col :span="24">-->
              <!--              <el-form-item label="渠道商利率：" prop="d__interestRate" :rules="{required: true, message: '渠道利率不能为空'}" style="width: 90%">-->
              <!--                <el-select placeholder="请选择渠道商利率" v-model.trim="dealerForm.d__interestType" >-->
              <!--                  <el-option :label="item.label" :value="item.value" v-for="(item,idx) in interestTypeOptions" :key="idx"></el-option>-->
              <!--                </el-select>-->
              <!--                <el-input type="number" v-model.trim="dealerForm.d__interestRate" style="width: 15%"></el-input><span id="unit">%</span>-->
              <!--              </el-form-item>-->
              <!--            </el-col>-->
                <el-col :span="12">
                    <el-form-item label="简码：" prop="d__prefix"  :rules="{required: true,max:5,min:1, message: '简码长度1-5'}" style="width: 60%">
                        <el-input v-model="dealerForm.d__prefix"></el-input>
                    </el-form-item>
                </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式：" prop="d__contactNo" style="width: 60%">
                  <el-input v-model="dealerForm.d__contactNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：" prop="d__disabled" :rules="{required: true, message: '状态不能为空'}"
                              style="width: 60%">
                  <el-select placeholder="请选择状态" v-model.trim="dealerForm.d__disabled">
                    <el-option :label="item.label" :value="item.value" v-for="(item,idx) in disabledOptions"
                               :key="idx"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                <el-col :span="12">
                    <el-form-item label="是否助贷：" prop="d__forLender" style="width: 60%">
                        <el-checkbox  v-model="dealerForm.d__forLender" false-label="N" true-label="Y"></el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
          </el-form>
        </panel>
      </el-col>
      <el-col>
        <panel label="成员用户">
          <el-button type="primary" @click="handleEditDealerUser" size="small">新增用户</el-button>
          <div class="xzpadd10 bg-purple of">
            <data-table
              :table-data="userTableData"
              :columns="userTableColumns"
              :isPaginationShow="false"
            />
          </div>
        </panel>
        <el-dialog :visible.sync="userFormDialogVisible" :title="userFormDialogTitle">
          <form-build
            form-name="userForm"
            :form-data.sync="userForm"
            :form-columns="userFormColumns"
            :form-rules="userFormRules"
            :form-buttons="userFormButtons"
            style="width: 400px"
          ></form-build>
        </el-dialog>

      </el-col>
      <el-col>
        <panel label="可用金融产品">
          <el-button type="primary" @click="handleEditDealerProduct" size="small">新增可用金融产品</el-button>
          <div class="xzpadd10 bg-purple of">
            <data-table
              :table-data="{data: dealerProducts.detail}"
              :columns="productTableColumns"
              :isPaginationShow="false"
            />
          </div>
        </panel>
        <el-dialog :visible.sync="productFormDialogVisible" :title="productFormDialogTitle">
          <form-build
            form-name="editForm"
            :form-data.sync="productForm"
            :form-columns="productFormColumns"
            :form-rules="productFormRules"
            :form-buttons="productFormButtons"
            style="width: 400px"
          ></form-build>
        </el-dialog>

      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button type="primary" @click="handleSaveDealer('dealerForm')">确认提交</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import interestTypeOptions from "../../utils/interestTypeOptions";
  import {removeItem} from "../../filters/CommonActions";

  export default {
    name: "DealerAdd",
    data() {
      return {
        dealerId: this.$route.query['dealerId'] || '',
        dealerForm: {
          d__disabled: 'N'
        },
        deviceTypeOptions: [],
        interestTypeOptions: [
          {
            label: '年利率',
            value: 'Yearly'
          },
          {
            label: '月利率',
            value: 'Monthly'
          },
          {
            label: '日利率',
            value: 'Daily'
          }
        ],
        disabledOptions: [
          {
            label: '启用',
            value: 'N'
          },
          {
            label: '禁用',
            value: 'Y'
          },
        ],
        dealerFormRules: {},
        productList: [],
        userTableData: {},
        userTableColumns: [
          {
            type: 'index'
          },
          {
            label: '用户名',
            field: 'du__userName'
          },
          {
            label: '手机号',
            field: 'du__mobileNo'
          },
          {
            label: '角色',
            field: 'r__role'
          },
          {
            label: '状态',
            field: 'du__disabled',
            formatter: function (r, c, v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作',
            opts: [
              {
                label: '删除',
                class: 'el-icon el-icon-delete',
                clickHandler: (index, row)=>{
                  this.removeUserItem(index, row)
                }
              }
            ]
          }
        ],
        userFormDialogVisible: false,
        userForm: {
          du__checked: true,
          du__userName: '',
          du__IC: '',
          du__dealerId: this.$route.query['dealerId'] || '',
          du__mobileNo: '',
          r__role: '',
          du__disabled: 'N',
          detail: [
            {
              detail__checked: true,
              r__role: '',
            }
          ]
        },
        userFormRules: {
          du__userName: [
            {
              required: true,
              message: '姓名不能为空！'
            }
          ],
          du__IC: [
            {
              required: true,
              message: '身份证号不能为空！'
            }
          ],
          du__mobileNo: [
            {
              required: true,
              message: '手机号不能为空！'
            }
          ],
          r__role: [
            {
              required: true,
              message: '角色不能为空！'
            }
          ],
          du__disabled: [
            {
              required: true,
              message: '状态不能为空！'
            }
          ],
        },
        userFormButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler: $refs => {
              $refs.validate(valid => {
                if (valid) {
                  this.handleSaveDealerUser()
                }
              })
            }
          },
          {
            label: '取消',
            // type: 'danger',
            clickHandler: $refs => {
              this.userFormDialogVisible = false
            }
          }
        ],
        dealerProducts: {
          detail: []
        },
        productTableColumns: [
          {
            type: 'index'
          },
          {
            label: '贷款产品',
            field: 'p__productName'
          },
          {
            label: '期限（月）',
            field: 'p__repaymentCount'
          },
          {
            label: '贷款利率',
            field: 'dp__customerInterestRate'
          },
          {
            label: '留存收益率',
            field: 'dp__dealerInterestRate'
          },
          {
            label: '罚息复利率',
            field: 'dp__penaltyInterestRate'
          },
          {
            label: '操作',
            opts: [
              {
                label: '编辑',
                class: 'el-icon el-icon-edit',
                clickHandler: (index, row)=> {
                    this.handleEditDealerProduct(index, row)
                }
              },
              {
                label: '删除',
                class: 'el-icon el-icon-delete',
                clickHandler: (idx)=> {
                  this.$confirm('你确认删除该贷款产品？').then(()=> {
                    this.dealerProducts.detail.splice(idx, 1)
                    this.handleSaveDealerProduct()
                  })
                  .catch(()=> {

                  })
                }
              }
            ]
          },
        ],
        productFormDialogVisible: false,
        productForm: {
          'dp__checked': true,
          'dp__productId': '',
          'dp__repaymentCount': 36,
          'dp__dealerInterestRate': '',
          'dp__dealerInterestType': 'Yearly',
          'dp__customerInterestRate': '',
          'dp__customerInterestType': 'Yearly',
          'dp__penaltyInterestRate': '',
          'dp__disabled': 'N'
        },
        productFormRules: {
          dp__productId: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          dp__dealerInterestRate: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          dp__customerInterestRate: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          dp__penaltyInterestRate: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          dp__customerInterestType: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          dp__dealerInterestType: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
        },
        productFormButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler: $refs => {
              $refs.validate(valid => {
                if (valid) {
                  this.handleSaveDealerProduct(this.productForm)
                }
              })
            }
          },
          {
            label: '取消',
            // type: 'danger',
            clickHandler: $refs => {
              this.productFormDialogVisible = false
            }
          }
        ]
      }
    },
    mounted() {
      if (this.dealerId) {
        this.getData()
        this.getDealerUserList()
        this.getDealerProductList()
      }
      this.getDealerType()
      this.getFinanceProductList()
    },
    computed: {
      userFormDialogTitle() {
        return this.userForm.du__userCode ? '编辑用户' : '新增用户'
      },
      productFormDialogTitle() {
        return this.productForm.p__productId ? '编辑可用金融产品' : '新增可用金融产品'
      },
      userFormColumns: {
        get() {
          return [
            {
              label: '姓名',
              component: 'el-input',
              field: 'du__userName',
              span: 24,
            },
            {
              label: '身份证号',
              component: 'el-input',
              field: 'du__IC',
              span: 24,
            },
            {
              label: '手机号',
              component: 'el-input',
              maxlength: 11,
              field: 'du__mobileNo',
              span: 24,
            },
            {
              label: '角色',
              component: 'el-select',
              field: 'r__role',
              span: 24,
              filterable: true,
              options: [
                {
                  label: '渠道商 进件',
                  value: '渠道商 进件',
                },
                {
                  label: '渠道商 初审',
                  value: '渠道商 初审',
                },
                {
                  label: '渠道商 内勤',
                  value: '渠道商 内勤',
                }
              ]
            },
            {
              label: '状态',
              component: 'el-select',
              field: 'du__disabled',
              span: 24,
              filterable: true,
              options: [
                {
                  label: '禁用',
                  value: 'Y',
                },
                {
                  label: '启用',
                  value: 'N',
                }
              ]
            },
          ]
        }
      },
      productFormColumns() {
        return [
          {
            label: '金融产品',
            component: 'el-select',
            field: 'dp__productId',
            options: this.productList.map(item=> ({
              label: item.p__productName,
              value: item.p__productId
            })),
            span: 24,
          },
          {
            label: '期限',
            field: 'dp__repaymentCount',
            formatter: (r)=> {
              return (this.productList.filter(item=>item.p__productId == r.dp__productId)[0]||{}).p__repaymentCount|| 0
            },
            unit: '月',
            span: 24,
          },
          {
            label: '贷款利率',
            component: 'el-input',
            maxlength: 11,
            field: 'dp__customerInterestRate',
            unit: '%',
            slots: [
              {
                slot: 'prepend',
                component: 'el-select',
                field: 'dp__dealerInterestType',
                props: {
                  style: 'width: 100px',
                  options: interestTypeOptions
                }
              }
            ],
            span: 24,
          },
          {
            label: '留存收益率',
            component: 'el-input',
            maxlength: 11,
            field: 'dp__dealerInterestRate',
            unit: '%',
            slots: [
              {
                slot: 'prepend',
                component: 'el-select',
                field: 'dp__dealerInterestType',
                props: {
                  style: 'width: 100px',
                  options: interestTypeOptions
                }
              }
            ],
            span: 24,
          },
          {
            label: '罚息复利率',
            component: 'el-input',
            maxlength: 11,
            field: 'dp__penaltyInterestRate',
            unit: '%',
            slots: [
              {
                slot: 'prepend',
                component: 'el-select',
                field: 'dp__dealerInterestType',
                props: {
                  style: 'width: 100px',
                  options: interestTypeOptions
                }
              }
            ],
            span: 24,
          }
        ]
      }
    },
    methods: {
      getData: function () {
        xhr.getDealer({
            'd.dealerId': this.dealerId
          },
          res => {
            try {
              if (res.data.status == 'success') {
                this.dealerForm = res.data.data
              }
            } catch (e) {

            }
          })
      },
      getDealerType: function () {
        xhr.getDealerType(
          Object.assign({}, {}, {}),
          res => {
            try {
              this.deviceTypeOptions = res.data.data.map(item => {
                return {
                  label: item.dt__name,
                  value: item.dt__dealerTypeId,
                }
              })
            } catch (e) {

            }
          })

      },

      getDealerUserList: function (customerId = this.customerId) {
        xhr.getDealerUserList(
          {
            'd.dealerId': this.dealerId
          },
          res => {
            try {
              if (res.data.status == 'success') {
                this.userTableData = res.data
              }
            } catch (e) {

            }
          }
        )
      },
      getDealerProductList: function () {
        xhr.getDealerProductList(
          {
            'd.dealerId': this.dealerId
          },
          res => {
            try {
              if (res.data.status == 'success') {
                res.data.data.detail = (res.data.data.detail||[]).filter(item=>item.dp__productId)
                this.dealerProducts = (res.data.data || {detail: []})
              }
            } catch (e) {

            }
          }
        )
      },
      getFinanceProductList: function() {
        xhr.getFinanceProductList(
          {
            pageSize: 0
          },
          res=> {
            if(res.data.status == 'success') {
              this.productList = res.data.data ||[]
            }
          }
        )
      },
      handleEditDealerUser: function (index, row = {}) {
        this.userFormDialogVisible = true
        this.userForm = Object.assign({
          du__checked: true,
          du__dealerId: this.dealerId,
          detail: [
            {
              detail__checked: true,
              r__role: '',
            }
          ]
        }, row)
      },
      handleEditDealerProduct: function (index, row = {}) {
        this.productFormDialogVisible = true
        this.productForm = Object.assign({
          'dp__checked': true,
          'dp__productId': '',
          'dp__repaymentCount': 0,
          'dp__dealerInterestRate': 0,
          'dp__dealerInterestType': 'Yearly',
          'dp__customerInterestRate': 0,
          'dp__customerInterestType': 'Yearly',
          'dp__penaltyInterestRate':0,
          'dp__disabled': 'N'
        }, row)
      },
      handleSaveDealer: function (formName) {
        let dealerForm = this.dealerForm
        this.$refs[formName].validate(valid => {
          if (valid) {
            dealerForm.d__checked = true
            xhr.updateDealer(dealerForm, res => {
              try {
                if (res.data.status == 'success') {
                  this.$router.push({
                    name: 'DealerListView'
                  })
                }
              } catch (e) {
              }
            })
          }
        })
      },
      handleSaveDealerUser: function () {
        this.userForm.detail[0].r__role = this.userForm.r__role
        xhr.updateDealerUser(
          this.userForm,
          res => {
            try {
              if (res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.userFormDialogVisible = false
                this.getDealerUserList()
                //this.getConfigDepartmentList()
              } else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            } catch (e) {

            }
          }
        )
      },
      handleSaveDealerProduct: function (row) {
        let postData = this.dealerProducts

        if( row ) {
          postData = Object.assign({}, this.dealerProducts)
          postData.detail = postData.detail.filter(item=> item.dp__entryId != this.productForm.dp__entryId)
          postData.detail.push(this.productForm)
        }

        xhr.updateDealerProduct(
          postData,
          res => {
            try {
              if (res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.productFormDialogVisible = false
                this.getDealerProductList()
              } else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            } catch (e) {

            }
          }
        )
      },
      removeUserItem: function (index, row) {
        removeItem(
          xhr.updateDealerUser,
          {
            'du.userId' : row.du__userId
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.getDealerUserList()
              }
            }catch (e) {

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/DealerEdit.vue